import { render, staticRenderFns } from "./BDMap.vue?vue&type=template&id=151da5d4&scoped=true"
import script from "./BDMap.vue?vue&type=script&lang=js"
export * from "./BDMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151da5d4",
  null
  
)

export default component.exports